import {useContext} from "react";
import {IsOnboardedContext} from "../../Contexts/IsOnboardedContext";
import {Navigate, Outlet} from 'react-router-dom';
const RequiresOnboarding = ({ children }) => {
    const context = useContext(IsOnboardedContext);
    if (!context.loggedIn) {
        return;
    }
    
    return !context.onboardedStatus 
        ? <Navigate to="/onboarding" />
        : <Outlet />;
}

export default RequiresOnboarding;